export default "__VITE_ASSET__8edOokWA__"